module.exports = __webpack_public_path__ + "assets/img/05.canal.2ee08b78.png";